import { createAction } from 'redux-actions';

const actions = {
    show: createAction('BANNER.REVEAL'),
    hide: createAction('BANNER.HIDE'),
};

/**
 * Reveals the banner
 * @returns {function(*): *}
 */
export const showBanner = addedProduct => {
    return dispatch => dispatch(actions.show(addedProduct));
}

/**
 * Hides the banner
 * @returns {function(*): *}
 */
export const hideBanner = () => {
    return dispatch => dispatch(actions.hide());
}

export default actions;
